if (!customElements.get('cart-offer-progress')) {
  class CartOfferProgress extends HTMLElement {
    constructor() {
      super();
      this.threshold = Number.parseInt(this.dataset.threshold, 10) || 3;
      this.messageEl = this.querySelector('[data-offer-message]');
      this.checkEl = this.querySelector('[data-offer-check]');
      this.fillEl = this.querySelector('[data-offer-fill]');
      this.trackEl = this.querySelector('.cart-offer-progress__track');
      this.steps = this.querySelectorAll('[data-offer-step]');
      this.unsubscribe = null;
      this.abortController = null;
    }

    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const itemCount = event?.cartData?.item_count;
          Number.isFinite(itemCount) ? this.render(itemCount) : this.fetchCart();
        });
      }
      this.fetchCart();
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
      this.abortController?.abort();
    }

    async fetchCart() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          signal: this.abortController.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (Number.isFinite(cart?.item_count)) this.render(cart.item_count);
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Cart offer progress could not refresh.');
      }
    }

    render(itemCount) {
      if (itemCount <= 0) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const cappedCount = Math.min(itemCount, this.threshold);
      const state = itemCount === 1 ? 'state-1' : itemCount === 2 ? 'state-2' : 'state-3';
      const progress = (cappedCount / this.threshold) * 100;

      this.dataset.itemCount = String(itemCount);
      this.classList.remove('cart-offer-progress--state-1', 'cart-offer-progress--state-2', 'cart-offer-progress--state-3');
      this.classList.add(`cart-offer-progress--${state}`);

      if (this.fillEl) this.fillEl.style.width = `${progress}%`;
      if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(cappedCount));

      this.steps.forEach((step, index) => {
        step.classList.toggle('is-complete', index < cappedCount);
      });

      if (this.messageEl) {
        const message = this.dataset[state.replace('-', '')] || this.dataset[state] || '';
        if (message) this.messageEl.textContent = message;
      }
      if (this.checkEl) this.checkEl.hidden = state !== 'state-3';
    }
  }

  customElements.define('cart-offer-progress', CartOfferProgress);
}


